import { useQuery } from '@tanstack/react-query'
import type { CategoryNode } from 'stoux-shared-types/services/category'

export function useCategories() {
    return useQuery({
        queryKey: ['categories'],
        queryFn: async () => {
            const res = await fetch('/api/categories')
            if (!res.ok) throw new Error('Failed to fetch categories')
            return (await res.json()) as CategoryNode
        },
        staleTime: 1000 * 60 * 60 * 3,
        gcTime: 1000 * 60 * 60 * 3,
    })
}
